import React, { useEffect, useState } from 'react';
import Button from "../../../ui/CTA/Button";
import Modal from "../../../ui/Modal";
import BodyText from "../../../ui/Typography/texts/BodyText";
import HeadingMedium from "../../../ui/Typography/titles/HeadingMedium";
import styles from './PriorPriceModal.module.scss';
const PriorPriceModal = ({ isOpen = false, onModalLinkOpen, onModalClosed, modalHeaderPriorPrice, modalHeaderAboutLegislation, modalTextPriorPriceInfo, modalTextPriorPriceDescription, modalTextAboutLegislation, modalLink, modalLinkHref, modalButtonLabelCancel, }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const onCancelButtonClick = () => {
        setIsModalOpen(false);
        if (onModalClosed) {
            onModalClosed();
        }
    };
    useEffect(() => {
        setIsModalOpen(isOpen);
    }, [isOpen]);
    if (isModalOpen && modalButtonLabelCancel) {
        return (React.createElement(Modal, { className: styles.modal, shouldDisableTitle: true, innerContainerClassName: styles.modalInnerContainer, textAlign: "left", toggleModal: () => {
                setIsModalOpen(false);
            }, isOpen: isModalOpen, closeButtonText: modalButtonLabelCancel, modalType: "middle", closeButtonPosition: "inside", onClosed: onCancelButtonClick, headingAlignment: "left", shouldPreventModalOverlay: !isModalOpen },
            modalHeaderPriorPrice && React.createElement(HeadingMedium, null, modalHeaderPriorPrice),
            modalTextPriorPriceInfo && React.createElement(BodyText, null, modalTextPriorPriceInfo),
            modalTextPriorPriceDescription && (React.createElement(BodyText, { className: styles.modalTextPriorPriceDescription }, modalTextPriorPriceDescription)),
            modalHeaderAboutLegislation && (React.createElement(HeadingMedium, null, modalHeaderAboutLegislation)),
            modalTextAboutLegislation && React.createElement(BodyText, null, modalTextAboutLegislation),
            modalLinkHref && modalLink && (React.createElement("a", { href: modalLinkHref, target: "_blank", rel: "noreferrer", onClick: onModalLinkOpen },
                React.createElement(BodyText, { className: styles.link }, modalLink))),
            React.createElement(Button, { primary: true, fullWidth: true, onClick: onCancelButtonClick }, modalButtonLabelCancel)));
    }
    return null;
};
export default PriorPriceModal;
//# sourceMappingURL=PriorPriceModal.js.map